import { render, staticRenderFns } from "./NormalSearchNav171.vue?vue&type=template&id=673b3d83&scoped=true&"
import script from "./NormalSearchNav171.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav171.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b3d83",
  null
  
)

export default component.exports